(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/people/:id', {
      templateUrl: 'modules/app/settings/your-organization/person/person.html',
      controller: 'PersonSettingsCtrl'
    });
  }]).controller('InvitePersonModalCtrl', ['$scope', '$uibModalInstance', '$http', 'Logger', 'Api', 'Utils', 'UserRoles', 'User', function ($scope, $uibModalInstance, $http, Logger, Api, Utils, UserRoles, User) {
    var user = User.get();
    $scope.invitation = {
      role: "user",
      organization: user.membership.organization,
      invitationUrlTemplate: Utils.qualifyURL("/app/outside.html#invitation-signup/{token}"),
      user: {
        name: $scope.entity.name,
        email: _.first($scope.availableEmailAddresses)
      }
    };
    $scope.availableRoles = ["user", "admin"];
    $scope.save = function () {
      $scope.sending = true;
      $http.post(Api.url("/memberships", true), $scope.invitation).then(function addUserSuccess(response) {
        // Keep the url around in case we need to delete with the PK right after adding.
        var id = Utils.getIdFromCreatedResponse(response);
        $scope.sending = false;

        // if it's a memberships location we added the org to an existing watershed user so not an invite.
        if (response.headers('location').indexOf("memberships") > 0) {
          $scope.invitation.id = id;
          $uibModalInstance.close($scope.invitation);
        } else {
          $scope.existingUserId = id;
          $uibModalInstance.close($scope.invitation);
        }
      }, function addUserError(response) {
        Logger.error("Error adding user " + $scope.invitation.user.email + ", response status " + response.status);
        if (response.status === 409) {
          $scope.saveError = "This user already exists in your organization.";
        } else {
          $scope.saveError = "There was error sending the invitation.";
        }
        $scope.sending = false;
      });
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('PersonPersonasModalCtrl', ['$scope', '$uibModalInstance', 'Api', '$http', 'Logger', 'Utils', function ($scope, $uibModalInstance, Api, $http, Logger, Utils) {
    $scope.excludedPeople = [$scope.entity.id];
    $scope.addPersona = function () {
      $scope.entity.personas.push({
        type: 'mbox',
        isNew: true
      });
    };
    $scope.$on("persona-created", function (evt, persona) {
      $scope.entity.personas.push(persona);
    });
    $scope.$on("persona-saved", function (evt, persona, index) {
      $scope.entity.personas[index] = persona;
    });
    $scope.$on("persona-deleted", function (evt, index) {
      $scope.entity.personas = Utils.removeAt($scope.entity.personas, index);
    });
    $scope.$on("person-merged", function (evt, person) {
      $scope.excludedPeople.push(person.id);
    });
    $scope.save = function () {
      $scope.sending = true;
      $http.put(Api.url("/people/" + $scope.entity.id), $scope.entity).then(function updateUserSuccess() {
        $uibModalInstance.close($scope.entity);
      }, function updateUserFailure(response) {
        Logger.error("Error saving person, response status " + response.status);
        var message = response.data.message;
        if (response.data.exceptionType === "javax.validation.ConstraintViolationException") {
          var entity = _.first(response.data.entity);
          message = entity.invalidValue + " " + entity.message;
        }
        $scope.saveError = "There was an error saving the person: " + message;
        $scope.sending = false;
      });
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('PersonPersonaItemCtrl', ['$scope', '$http', 'Api', 'Logger', 'Utils', 'Validation', function ($scope, $http, Api, Logger, Utils, Validation) {
    function validateForm() {
      var errors = Validation.validate({
        "email": {
          "rules": {
            "required": $scope.type === 'mbox',
            "email": true
          },
          "value": $scope.editCopy.mbox
        },
        "openid": {
          "rules": {
            "required": $scope.type === 'openid'
          },
          "value": $scope.editCopy.openid
        },
        "homePage": {
          "rules": {
            "required": $scope.type === 'account'
          },
          "value": $scope.editCopy.account ? $scope.editCopy.account.homePage : ""
        },
        "name": {
          "rules": {
            "required": $scope.type === 'account'
          },
          "value": $scope.editCopy.account ? $scope.editCopy.account.name : ""
        },
        "email_sha1": {
          "display": "Email SHA1",
          "rules": {
            "required": $scope.type === 'mbox_sha1sum',
            "minLength": 40,
            "maxLength": 40
          },
          "value": $scope.editCopy.mbox_sha1sum
        }
      });
      if (errors === null && $scope.editCopy.hasOwnProperty('account')) {
        _.each($scope.entity.personas, function (p) {
          if (p.hasOwnProperty('account') && p.account.homePage.toLowerCase() === $scope.editCopy.account.homePage.toLowerCase() && p.account.name.toLowerCase() === $scope.editCopy.account.name.toLowerCase()) {
            errors = {};
            if (p.account.homePage !== $scope.editCopy.account.homePage) {
              errors.accountHomePage = "Account already exists.  HomePage is case insensitive";
            }
            if (p.account.name !== $scope.editCopy.account.name) {
              errors.accountName = "Account already exists.  Name is case insensitive";
            }
            // Check for complete duplicate also
            if (p.account.homePage === $scope.editCopy.account.homePage && p.account.name === $scope.editCopy.account.name) {
              errors.accountName = "Account already exists.";
            }
          }
        });
      }
      return errors;
    }
    function resetEditingState() {
      $scope.editCopy = angular.copy($scope.persona) || {};
      if ($scope.editCopy.mbox) {
        $scope.editCopy.mbox = $scope.editCopy.mbox.replace("mailto:", "");
      }
      $scope.editing = false;
      $scope.type = null;
      $scope.formErrors = null;
      $scope.selectedPerson = null;
    }
    resetEditingState();

    // Newly added rows will have a "new" property which we use to immediately show the editing view
    if ($scope.persona.isNew === true) {
      $scope.editing = true;
      $scope.type = 'mbox';
      delete $scope.persona.isNew;
    }
    $scope.personSelected = function (person) {
      $scope.selectedPerson = person;
    };
    $scope.save = function save() {
      $scope.formErrors = validateForm();
      if ($scope.formErrors !== null) {
        return;
      }
      if ($scope.type === 'person') {
        _.each($scope.selectedPerson.parentGroupIds, function (gId) {
          if ($scope.entity.parentGroupIds.indexOf(gId) < 0) {
            $scope.entity.parentGroupIds.push(gId);
          }
        });
        _.each($scope.selectedPerson.personas, function (persona) {
          $scope.$emit("persona-created", persona);
        });
        $scope.$emit("persona-deleted", $scope.$index);
        $scope.$emit("person-merged", $scope.selectedPerson);
      } else {
        $scope.editCopy.isNew = null;
        if ($scope.editCopy.mbox) {
          $scope.editCopy.mbox = "mailto:" + $scope.editCopy.mbox;
        }
        $scope.$emit("persona-saved", $scope.editCopy, $scope.$index);
      }
      resetEditingState();
    };
    $scope.cancel = function cancel() {
      if ($scope.editCopy.isNew) {
        $scope.remove();
      } else {
        resetEditingState();
      }
    };
    $scope.remove = function remove() {
      $scope.$emit("persona-deleted", $scope.$index);
    };
  }]).controller('PersonPermissionsCtrl', ['$scope', '$routeParams', '$controller', 'Api', function ($scope, $routeParams, $controller, Api) {
    var personId = $routeParams.id;
    $scope.personId = personId;
    $scope.permissionsApiUrl = Api.url("/people/" + personId + "/permissions");
    $scope.targetingPermissionsApiUrl = Api.url("/people/" + personId + "/targeting-permissions");
  }]).controller('PersonSettingsCtrl', ['$scope', '$controller', '$routeParams', '$uibModal', '$http', 'Api', 'Logger', function ($scope, $controller, $routeParams, $uibModal, $http, Api, Logger) {
    $scope.personId = $routeParams.id;
    $scope.save = function () {
      $scope.saving = true;
      $http.put(Api.url("/people/" + $scope.entity.id), $scope.entity).then(function updateGroupSuccess() {
        $scope.saving = false;
      }, function updateGroupFailure(response) {
        Logger.error("Error saving person, response status " + response.status);
        $scope.saveError = "There was an error updating the person: " + response.data.message;
        $scope.saving = false;
      });
    };
    $scope.$on('name-changed', function () {
      $scope.save();
    });

    //set these two properties to be used by uploadImageModal
    $scope.uploadUrl = '/images';
    $scope.isOrgLogoImage = true;
    $scope.openImageModal = function () {
      $scope.uploadImageModal = $uibModal.open({
        templateUrl: "modules/common/images/upload-image-modal.html",
        controller: "UploadImageCtrl",
        backdrop: 'static',
        scope: $scope
      });

      // The modal "resolves" to (closes with) image url
      $scope.uploadImageModal.result.then(function (imageUrl) {
        $scope.entity.imageUrl = imageUrl;
        $scope.save();
      });
    };

    //delete image url from organization
    $scope.clearImage = function () {
      $scope.entity.imageUrl = null;
      $scope.save();
    };
    $scope.invitePersonModal = function () {
      $uibModal.open({
        templateUrl: 'modules/app/settings/your-organization/modals/invite-person-modal.html',
        controller: 'InvitePersonModalCtrl',
        backdrop: 'static',
        scope: $scope
      });
    };
    $scope.openPersonasModal = function () {
      $uibModal.open({
        templateUrl: 'modules/app/settings/your-organization/modals/person-personas-modal.html',
        controller: 'PersonPersonasModalCtrl',
        backdrop: 'static',
        scope: $scope
      });
    };
    $controller('PersonGroupSettingsCtrl', {
      $scope: $scope
    });
  }]);
})();
